import { render, staticRenderFns } from "./ManageFavoriteVariantCharacters.vue?vue&type=template&id=77ebc3a7&scoped=true&"
import script from "./ManageFavoriteVariantCharacters.vue?vue&type=script&lang=js&"
export * from "./ManageFavoriteVariantCharacters.vue?vue&type=script&lang=js&"
import style0 from "./ManageFavoriteVariantCharacters.vue?vue&type=style&index=0&id=77ebc3a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ebc3a7",
  null
  
)

export default component.exports